export default __webpack_public_path__ + "static/media/creators.59e1bb25.svg";